import { uploadImageSmart, uploadFileSmart } from '@/utils/fileUpload'

// Restore the legacy OSS upload path without local tasks or admission polling.
export function uploadVideoReferenceImage(file, options = {}) {
  return uploadImageSmart(file, options)
}

export function uploadVideoReferenceFile(file, category, options = {}) {
  return uploadFileSmart(file, category, options)
}

export async function uploadAssetReference(file, assetType) {
  const category = assetType.toLowerCase()
  const imageUrl = category === 'image'
    ? await uploadImageSmart(file, { compress: true }) : await uploadFileSmart(file, category)
  return { imageUrl }
}
